<template>
	<div class="contacto">
		<a v-if="whatsapp" target="_blank" :href="whatsapp.url">
			<figure>
				<img src="/img/whatsapp_logo.png" alt="Whatsapp">
			</figure>
		</a>
		<a v-if="instagram" target="_blank" :href="instagram.url">
			<figure>
				<img src="/img/instagram_logo.png" alt="Instagram">
			</figure>
		</a>
		<a v-if="facebook" target="_blank" :href="facebook.url">
			<figure>
				<img src="/img/facebook_logo.png" alt="Facebook">
			</figure>
		</a>
		<a v-if="twitter" target="_blank" :href="twitter.url">
			<figure>
				<img src="/img/twitter_logo.png" alt="Twitter">
			</figure>
		</a>
		<a v-if="linkedin" target="_blank" :href="linkedin.url">
			<figure>
				<img src="/img/linkedin_logo.png" alt="Linkedin">
			</figure>
		</a>
		<a v-if="youtube" target="_blank" :href="youtube.url">
			<figure>
				<img src="/img/youtube_logo.png" alt="Youtube">
			</figure>
		</a>
		<a v-if="correoElectrónico" target="_blank" :href="`mailto:${correoElectrónico.dirección}`">
			<VIcono v-model="íconoCorreo" tamaño="2em"></VIcono>
		</a>
		<a v-if="númeroTelefónico" target="_blank" :href="`tel:${númeroTelefónico.normalizado}`">
			<VIcono v-model="íconoTeléfono" tamaño="2em"></VIcono>
		</a>
	</div>
</template>

<script>
import VIcono from '@/components/base/VIcono.vue'

export default {
	name: 'VContacto',

	data: () => ({
		íconoCorreo: {
			estilo: 'contorneado',
			identificador: 'mail'
		},
		íconoTeléfono: {
			estilo: 'contorneado',
			identificador: 'phone'
		}
	}),

	props: {
		value: {
			type: Object,
			required: true
		},
	},

	components: {
		VIcono
	},

	computed: {
		correoElectrónico: function() {
			let valor = (this.value.medios.correoElectrónico.valor || '').trim().toLowerCase()
			if (!valor) {
				return null
			}

			return { dirección: valor }
		},
		númeroTelefónico: function() {
			let valorVisible = (this.value.medios.númeroTelefónico.valor || '').trim()
			let valorNormalizado = valorVisible.replace(/(\s|\+|\-|\(|\))/g, '')
			if (!valorNormalizado) {
				return null
			}

			return {
				visible: valorVisible,
				normalizado: valorNormalizado,
			}
		},
		whatsapp: function() {
			let valor = (this.value.medios.whatsapp.valor || '').trim().toLowerCase()
			valor = valor.replace(/^(https?:\/\/)?wa\.me(\/|$)/, '').replace(/\/$/, '')
			valor = valor.replace(/(\s|\+|\-|\(|\))/g, '')
			return this.asegurarURLONull(valor, `https://wa.me/${valor}`)
		},
		instagram: function() {
			let valor = (this.value.medios.instagram.valor || '').trim().toLowerCase()
			valor = valor.replace(/^((https?:\/\/)?www\.)?instagram\.com(\/|$)/, '').replace(/\/$/, '')
			return this.asegurarURLONull(valor, `https://www.instagram.com/${valor}`)
		},
		facebook: function() {
			let valor = (this.value.medios.facebook.valor || '').trim()
			valor = valor.replace(/^((https?:\/\/)?www\.)?facebook\.com(\/|$)/, '').replace(/\/$/, '')
			return this.asegurarURLONull(valor, `https://www.facebook.com/${valor}`)
		},
		twitter: function() {
			let valor = (this.value.medios.twitter.valor || '').trim()
			valor = valor.replace(/^((https?:\/\/)?www\.)?twitter\.com(\/|$)/, '').replace(/\/$/, '')
			return this.asegurarURLONull(valor, `https://twitter.com/${valor}`)
		},
		linkedin: function() {
			let valor = (this.value.medios.linkedin.valor || '').trim()
			valor = valor.replace(/^((https?:\/\/)?www\.)?linkedin\.com(\/|$)/, '').replace(/\/$/, '')
			return this.asegurarURLONull(valor, `https://www.linkedin.com/${valor}`)
		},
		youtube: function() {
			let valor = (this.value.medios.youtube.valor || '').trim()
			return this.asegurarURLONull(valor, `https://www.youtube.com/${valor}`)
		}
	},

	methods: {
		asegurarURL: function(valor1, valor2) {
			return valor1.indexOf('https://') === 0 || valor1.indexOf('http://') === 0 ? valor1 : valor2
		},
		asegurarURLONull: function(valor1, valor2) {
			if (!valor1) {
				return null
			}

			return {
				url: this.asegurarURL(valor1, valor2)
			}
		}
	}

}
</script>

<style scoped>

a {
	color: white !important;
}

</style>